import React, {PropTypes} from 'react';
import {connect} from 'react-redux';
import SplashMessageContainer from '../core/containers/SplashMessageContainer'
const queryString = require('query-string');

const mapStateToProps = (state, ownProps) => {
  const query = queryString.parse(ownProps.location.search)
  return {
    query
  }
}

export default connect(mapStateToProps)(SplashMessageContainer)



// WEBPACK FOOTER //
// ./src/core/SplashMessagePage.js